// Google Ads (gclid, plus gbraid/wbraid for iOS) and Microsoft Ads (msclkid) click IDs
const CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid', 'msclkid'];
const STORAGE_KEY = 'clickIds';

// Ad clicks land on any page so keep the IDs for the session until a form is sent
export const storeClickIds = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = Object.fromEntries(
      CLICK_ID_PARAMS.filter((param) => params.get(param)).map((param) => [param, params.get(param)])
    );
    if (Object.keys(found).length) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(found));
  } catch {}
};

export const getClickIds = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};
